// extracted by mini-css-extract-plugin
module.exports = {"appMain":"App_appMain__36tZ4"};